export const DATADOG_API_KEY = process.env.DATADOG_API_KEY
export const DATADOG_SERVICE_NAME =
  process.env.DATADOG_SERVICE_NAME || 'accentro-web'
